// extracted by mini-css-extract-plugin
export default {"agenda":"lIGFA230","logo":"xmbtDHSh","mobile":"mobile"};